import React, {useState, useEffect} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import SMCButton from '../../components/Simple/SMCButton';
import {validateIpAddress} from '../../utils/utils';
import {SystemSettingsGetSchema} from '../../api/DBSchema/SystemSettings';
import {useSMCSnackbar} from '../../utils/hooks';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import EmptyRow from '../../components/Simple/EmptyRow';

const pageSchema = SystemSettingsGetSchema.pages.licenseManagement.licensesListSchema;

function SystemLicenseEditorModal({
    isOpen,
    onRequestClose,
    onSuccess,
    defaultObject,
    title
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();

    const [ipAddress, setIpAddress]  = useState('');
    const [expirationDate, setExpirationDate] = useState('');
    const [signature, setSignature] = useState('');
    const [featuresString, setFeaturesString] = useState('');
    

    const onFinish = () => {
        // Validate
        if (!ipAddress || !expirationDate || !signature || !featuresString) {
            enqueueErrorSnackbar(
                <>
                {t('com.sofaware.db.OBJECT_NOT_VALID')}
                { !ipAddress && <><br />{t('com.sofaware.schema.ATTRIBUTE_REQUIRED_VALUE_MISSING', [t('SMP.ADD_SMP_LICENSE.IP_ADDRESS')])}</>}
                { !expirationDate && <><br />{t('com.sofaware.schema.ATTRIBUTE_REQUIRED_VALUE_MISSING', [t('SMP.ADD_SMP_LICENSE.EXPIRATION_DATE')])}</>}
                { !signature && <><br />{t('com.sofaware.schema.ATTRIBUTE_REQUIRED_VALUE_MISSING', [t('SMP.ADD_SMP_LICENSE.SIGNATURE')])}</>}
                { !featuresString && <><br />{t('com.sofaware.schema.ATTRIBUTE_REQUIRED_VALUE_MISSING', [t('SMP.ADD_SMP_LICENSE.SKU')])}</>}
                </>
            , {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }

        if (!validateIpAddress(ipAddress)) {
            enqueueErrorSnackbar(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_IP', [ipAddress, t('SMP.PLAN.ADMIN_ACCESS_WIZ.IP_ADDRESS')]), {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }

        const retVal = {
            [pageSchema.ip]: ipAddress,
            [pageSchema.expirationDate]: expirationDate,
            [pageSchema.signature]: signature,
            [pageSchema.featureList]: [featuresString]
        }

        onSuccess(retVal);
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            if (defaultObject) {
                setIpAddress(defaultObject[pageSchema.ip]);
                setExpirationDate(defaultObject[pageSchema.expirationDate]);
                setSignature(defaultObject[pageSchema.signature]);
                setFeaturesString(defaultObject[pageSchema.featureList]?.join(', '));
            } else {
                setIpAddress('');
                setExpirationDate('');
                setSignature('');
                setFeaturesString('');
            }
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={480}
            title={title || t('SMP.ADD_SMP_LICENSE.HEADING')}
            onRequestClose={onRequestClose}
        >
            <SMCModalBody>
                <SMCLabel bold>{t('SMP.ADD_SMP_LICENSE.ADD_LICENSE')}</SMCLabel>
                <SMCTextInput
                    value={ipAddress}
                    onChange={e => setIpAddress(e.target.value)}
                    label={t('SMP.ADD_SMP_LICENSE.IP_ADDRESS')}
                />
                <SMCTextInput
                    value={expirationDate}
                    onChange={e => setExpirationDate(e.target.value)}
                    label={t('SMP.ADD_SMP_LICENSE.EXPIRATION_DATE')}
                />
                <SMCTextInput
                    value={signature}
                    onChange={e => setSignature(e.target.value)}
                    label={t('SMP.ADD_SMP_LICENSE.SIGNATURE')}
                />
                <SMCTextInput
                    value={featuresString}
                    onChange={e => setFeaturesString(e.target.value)}
                    label={t('SMP.ADD_SMP_LICENSE.SKU')}
                />

                <EmptyRow />

                <SMCLabel fontSize="11px">{t('SMP.ADD_SMP_LICENSE.NOTE')}</SMCLabel>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton> 
            </SMCModalButtonContainer>
        </SMCModal>

    );
}

export default SystemLicenseEditorModal;